import SEOLandingTemplate from './SEOLandingTemplate';

export default function OnPageCheckerPageSEO() {
  return (
    <SEOLandingTemplate
      title="On-Page SEO Checker"
      metaTitle="Free On-Page SEO Checker | Sungresh"
      metaDescription="Analyze any live page against a target keyword: title, meta tags, headings, content, and internal links, with a score and specific recommendations."
      h1="Free On-Page SEO Checker"
      sub="Enter a URL and a target keyword. A live crawler fetches the page and checks it against on-page fundamentals: title, meta description, headings, keyword placement, images, and links."
      keywords="on page seo checker, on page seo tool, on page checker"
      ctaLink="/audit/onpage"
      ctaText="Check a Page Free"
      features={[
        { icon: '💯', title: 'On-Page Score', desc: 'An overall score based on the checks below' },
        { icon: '📝', title: 'Title & Meta', desc: 'Checks whether the keyword appears in your title and meta description' },
        { icon: '🔤', title: 'Headings & Content', desc: 'H1 presence, content length, and keyword placement' },
        { icon: '🖼️', title: 'Images & Links', desc: 'Alt text coverage and internal/external link counts' },
        { icon: '💡', title: 'Recommendations', desc: 'Specific, actionable fixes for what the checker finds' },
      ]}
      faqs={[
        { q: 'How does this checker get its data?', a: 'It performs a real live HTTP fetch of your URL and parses the actual HTML — it\'s not working from a cached or simulated version of your page.' },
        { q: 'What does the score mean?', a: 'It reflects how well the page follows established on-page SEO fundamentals for your target keyword. A higher score generally means fewer obvious on-page gaps, though it isn\'t a guarantee of ranking position.' },
        { q: 'What are the most common issues this catches?', a: 'Missing or generic title tags, a target keyword that never appears in the H1 or opening paragraph, thin content, and images without alt text are the most frequent findings.' },
      ]}
    />
  );
}
